import { request } from "../../../config/helpers/axios-instance";
import { useQuery } from "react-query";

const fetchLsqAdminUserById = (userId, enabled) => {
    return useQuery(
        ["lsq-admin-user", userId],
        () =>
            request({
                url: `lsq/admin/user/${encodeURIComponent(userId)}`,
                method: "GET",
            }),
        { enabled: Boolean(userId) && Boolean(enabled) }
    );
};

export { fetchLsqAdminUserById };
